<template>
    <div class="block">
        <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                <tr>
                    <th></th>
                    <th>Melding</th>
                    <th>Datum</th>
                    <th class="text-right">Actie</th>
                </tr>
                </thead>
                <tbody ref="tbody">
                </tbody>
            </table>
        </div>
        <div @click="get_next_notifications('is_not_initial')" ref="get_next_notifications" class="d-none justify-center cursor-pointer mt-3 look-next">
            <p class="text-primary mb-0 font-size-20"><i class="fas fa-plus font-size-16"></i> Bekijk meer</p>
        </div>
    </div>

</template>

<script>
    export default {
        data() {
            return {
                offset: 0,
                getting_next_notifications: false,
            }
        },
        mounted() {
            this.get_next_notifications('is_not_initial');
        },
        methods: {
            get_next_notifications: function (initial) {
                if(!this.getting_next_notifications)
                {
                    this.getting_next_notifications = true;
                    let axios = require('axios');
                    axios.get('/notifications/get-for-index?offset=' + this.offset + '&initial=' + initial)
                        .then((response) => {
                        let notifications = response.data['notifications'];

                            for(let key in notifications)
                            {
                                let notification = notifications[key];
                                let td;

                                let tr = document.createElement('tr');
                                tr.classList = notification['tr_class'];

                                td = document.createElement('td');
                                let div = document.createElement('div');
                                div.classList = notification['bg_class'] + ' preview-icon';
                                let i = document.createElement('i');
                                i.classList = notification['icon'] + ' mx-0';
                                div.appendChild(i);
                                td.appendChild(div);
                                tr.appendChild(td);

                                td = document.createElement('td');
                                let p = document.createElement('p');
                                p.classList = 'mw-300 ws-normal mb-0';
                                p.innerHTML = notification['description'];
                                td.appendChild(p);
                                tr.appendChild(td);

                                td = document.createElement('td');
                                td.innerHTML = notification['date'];
                                tr.appendChild(td);

                                td = document.createElement('td');
                                td.classList = 'text-right';
                                let a = document.createElement('a');
                                a.setAttribute('href', notification['url']);
                                a.classList = 'btn btn-primary';
                                a.innerHTML = 'Bekijken';
                                td.appendChild(a);
                                tr.appendChild(td);

                                this.$refs['tbody'].appendChild(tr);
                            }

                            if(response.data['got_last'])
                            {
                                this.$refs['get_next_notifications'].classList.remove('d-flex');
                                this.$refs['get_next_notifications'].classList.add('d-none');
                            }
                            else
                            {
                                this.$refs['get_next_notifications'].classList.add('d-flex');
                                this.$refs['get_next_notifications'].classList.remove('d-none');
                                this.offset += 5;
                                this.getting_next_notifications = false;
                            }
                        });
                }
            }
        }
    }
</script>
